
























































































































import Vue, { PropType } from "vue"
import PExperiencedProject from "./PExperiencedProject.vue"
import RowGroup from "~/components/guideline/util/RowGroup.vue"
import ColumnWithIcon from "~/components/guideline/util/ColumnWithIcon.vue"
import {
  CORPORATION_ICON,
  CALENDAR_ICON,
  BUSINESS_ICON,
  PEOPLE_ICON,
  DESCRIPTION_ICON,
  LINK_ICON,
} from "~/config/icon"
import EditLinkIcon from "~/components/guideline/icon/EditLinkIcon.vue"
import EditLinkWithDropdownMenu from "~/components/guideline/icon/EditLinkWithDropdownMenu.vue"
import MaterialIcon, {
  OUTLINED,
} from "~/components/guideline/icon/MaterialIcon.vue"
import {
  UserProfileExperienceCorporationView,
  decorateUserProfileExperienceCorporationView,
} from "~/clApi/viewModel"

export default Vue.extend({
  components: {
    RowGroup,
    ColumnWithIcon,
    EditLinkIcon,
    EditLinkWithDropdownMenu,
    MaterialIcon,
    PExperiencedProject,
  },
  props: {
    career: {
      type: Object as PropType<UserProfileExperienceCorporationView>,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    careersLength: {
      type: Number,
      required: true,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
    isPropDetailExpanded: {
      type: Boolean,
      default: false,
    },
    isMultipleCareers: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      icon: {
        corporation: CORPORATION_ICON,
        calendar: CALENDAR_ICON,
        business: BUSINESS_ICON,
        people: PEOPLE_ICON,
        description: DESCRIPTION_ICON,
        link: LINK_ICON,
      },
      iconType: {
        OUTLINED,
      },
      isDetailExpanded: this.isPropDetailExpanded,
    }
  },
  computed: {
    workSpanText(): string {
      return decorateUserProfileExperienceCorporationView(
        this.career
      ).getWorkSpanText()
    },
    editLinkPath(): string {
      return this.isEditable ? `/profiles/edit/career/${this.index}` : ""
    },
    hasMultipleCareers(): boolean {
      return this.careersLength > 1
    },
  },
  methods: {
    changeIsDetailExpanded() {
      this.isDetailExpanded = !this.isDetailExpanded
    },
    editCareer() {
      this.$nuxt.$router.push({ path: this.editLinkPath })
    },
    handleClickCareerDeleteButton() {
      this.$emit("click-career-delete-button")
    },
  },
})
